export * from './design-system-provider-app-directory';

//# sourceMappingURL=index.js.map